import React from 'react';
import { useNavigate } from 'react-router-dom';
import { apiConstants } from '../_constants';
import { trimString } from '../_services/misc.service';
import './home.css';

export const CourseBox = ({ courseData }) => {
  const navigate = useNavigate();
  return (
    <div
      className='coursebox'
      onClick={() => courseData?.isactive == 1 && navigate(`/course/${courseData?._id}`)}
    >
      <div className='d-flex gap-2'>
        <img
          src={
            courseData?.image ? apiConstants.imgUrl + courseData?.image : '/img/course_dummy.png'
          }
          className='course_img'
        />
        <div className='contentbox'>
          <div className='coursename'>{trimString(courseData?.course_name, 30)}</div>
          {courseData?.isactive !== 1 && <img src='img/lockicon.png' className='lockicon' />}
          <div className='coursedesc d-flex'>
            <div className='topics'>
              <img src='img/book_icon.png' className='desc_icon' /> {courseData?.total_topics}{' '}
              Topics
            </div>
            <div className='topics'>
              <img src='img/question_icon.png' className='desc_icon' />{' '}
              {courseData?.total_questions} Questions
            </div>
          </div>
        </div>
      </div>
      {courseData?.progress && (
        <div className='porgressbarcontainer'>
          <div className='courseprogresscontainer'>
            <div className='courseprogress' style={{ width: `${courseData?.progress}%` }}></div>
          </div>
        </div>
      )}
    </div>
  );
};
